import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {
  FidjiPublicationWebService, IMPublicationTheme, IMPublication
} from '@immanens-com/fidji-api-module';
import {UserControllerService} from '../user/user-controller.service';
import {Subject} from 'rxjs/Subject';
import {map, tap} from 'rxjs/operators';
import {log} from 'util';

@Injectable()
export class PublicationControllerService {

  // private publicationsSubject = new BehaviorSubject<IMPublication[]>([]);
  // public publications: Observable<IMPublication[]> = this.publicationsSubject.asObservable();

  public userPublicationsSubject = new BehaviorSubject<IMPublication[]>([]);
  public userPublications = this.userPublicationsSubject.asObservable();

  private themesSubject = new BehaviorSubject<IMPublicationTheme[]>([]);
  public themes: Observable<IMPublicationTheme[]> = this.themesSubject.asObservable();

  private orderedPublicationSubject = new BehaviorSubject<{dly_pub_id: string}[]>([]);

  constructor(private http: HttpClient,
              private publicationWS: FidjiPublicationWebService,
              private userCtrl: UserControllerService) {

    this.subscribeToIsLoggedChange();
    this.loadThemes();
    this.load();
  }

  private subscribeToIsLoggedChange(): void {
    this.userCtrl.isLoggedChange.subscribe((isLogged) => {
      if (isLogged) {
        this.loadUserPublications();
      }
    });
  }

  public load() {
    // this.loadPublications();
    if (this.userCtrl.isLogged) {
      this.loadUserPublications();
    }
  }

  private loadThemes(): void {
    this.http
      .get<IMPublicationTheme[]>('assets/publication-themes.json').subscribe((themes) => {
      this.themesSubject.next(themes);
    });
  }

  // private loadPublications(): void {
  //   this.publicationWS.publicationList()
  //     .map(list => {

  //       const orderedPublications = list.models.splice(0, 0);

  //       for (const pub of list.models) {
  //         const index = this.indexInPublicationOrderedList(pub.dly_pub_id);
  //         orderedPublications[index] = pub;
  //       }

  //       return orderedPublications;
  //     })
  //     .toPromise()
  //     .then(pubList => this.publicationsSubject.next(pubList));
  // }

  public loadUserPublications(): void {
    this.publicationWS.userPublicationList(0, {order: 'title_asc'}).toPromise().then((list) => {
      this.userPublicationsSubject.next(list.models);
    });
  }

  public publicationByDocument(documentId: number): Observable<IMPublication> {

    return this.userPublications.map((publications) => {
      if (publications == null) {
        return null;
      }

      const index = publications.findIndex((publication) => {
        return publication.doc_data.dly_doc_id === documentId;
      });

      if (index === -1) {
        return null;
      } else {
        return publications[index];
      }
    });
  }

  public publicationById(dly_pub_id: string): Observable<IMPublication> {
    return this.userPublications.map((pubList) => {
      if (pubList != null) {
        return pubList.find((pub) => pub.dly_pub_id === dly_pub_id);
      }
    });
  }

  /**
   * Get related theme for a single publication.
   * If there is no theme, return an object with pub_id = -1
   * @param {IMPublication} publication
   * @returns Promise<IMPublicationTheme>
   */
  public themeForPublicationId(dly_pub_id: string): Observable<IMPublicationTheme> {

    return this.themes.map((themes) => {

      const index = themes.findIndex(theme => {
        return theme.dly_pub_id === dly_pub_id;
      });

      if (index === -1) {
        // No theme found for this publication
        return {color: 'White', dly_pub_id: '-1'} as IMPublicationTheme;
      } else {

        return themes[index];
      }
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/publication/publication-controller.service.ts